import gql from 'graphql-tag';

export default gql`
  query ordersOrFulfillmentNotes($filter: OrderOrFulfillmentNoteFilterInput, $pagination: Pagination!) {
    ordersOrFulfillmentNotes(pagination: $pagination, filter: $filter) {
      totalPage
      totalResults
      data {
        ... on Order {
          id
          total
          totalItemPrice
          grossTotal
          orderDate
          status
          statusText
          paymentMethod
          note
          declineReason
          approvedAt
          redelivery
          orderType
          discount
          store {
            id
          }
          deliveryTime {
            start
            end
          }
          items {
            total
            orderedQuantity
            deliveryQuantity
            note
            buyerNote
            deliveredNote
            price
            unitPriceAfterDiscount
            amountAfterDiscount
            quantity
            orderedGrossPrice
            grossTotal
            previousQuantity
            grossPrice
            deliveredQuantity
            orderedPrice
            priceV2 {
              price
              originalPrice
              vat
              vatIncluded
            }
            product {
              id
              name
              supplierInternalCode
              imageUrl
              imageFilePath
              note
              description
              details
              origin
              preservationLocal
              preservation
              vat
              uomLocal
              uom
              price
              originalPrice
              grossPrice
              offMarket
              inStock
              private
              disabled
              isFavorite
              tags
              createdAt
              updatedAt
              allowAddToCart
              allowPurchase
              tagImageVn
              tagImageEn
              baseUom
              baseUnit
              baseUomPrice
              netUomPrice
              netUom
              netUnit
            }
          }
        }
        ... on FulfillmentNote {
          fulfillmentNoteId
          fulfillmentNoteShortCode
          deliveryStartDateTime
          deliveryEndDateTime
          orderDateTime
          paymentMethod
          total
          discount
          itemCount
          fulfillmentNoteStatus
          orderIds
          orders {
            id
            total
            totalItemPrice
            grossTotal
            orderDate
            status
            statusText
            paymentMethod
            note
            declineReason
            approvedAt
            redelivery
            orderType
            discount
            store {
              id
            }
            items {
              product {
                id
                name
                supplierInternalCode
                imageUrl
                imageFilePath
              }
            }
          }
          feedback {
            id
            objectType
            objectId
            submittedByUserId
            rating
            tags
            comment
            dismissedAt
            submittedAt
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
